module.exports = __webpack_public_path__ + "media/images/arrows-ffffff-18477b681732b5c2d582126e5e07c8b4.png";